import { environment } from "../environment";
import { Club } from "../models/club";
import { userClubActions, ClubUser } from "../models/clubUser";
import { AsyncResult } from "../models/common/async-result";
import { PaginatedResult } from "../models/common/paginate";
import api from "./api";

export async function getAllClub(page: number): Promise<PaginatedResult<Club>> {
  const baseUrl = environment.api.club.getAll

  const url = baseUrl
    .replace('{page}', String(page || 0))

  return await api.get(url)
    .then(resp => resp?.data.success)
    .catch(error => error.response.data);
}

export async function createClub(book: Club, userId: number): Promise<AsyncResult<Club>> {
  const url = environment.api.club.create
    .replace('{userId}', String(userId))

  return await api.post(url, book)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } })
}

export async function editClub(clubId: number, book: Club, userId: number): Promise<AsyncResult<number>> {
  const url = environment.api.club.edit
    .replace('{userId}', String(userId))
    .replace('{clubId}', String(clubId))

  return await api.put(url, book)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } })
}

export async function getClub(clubId): Promise<Club> {
  const url = environment.api.club.get
    .replace('{clubId}', String(clubId))

  return await api.get(url)
    .then(resp => resp?.data.success)
    .catch(error => error.response.data);
}

export async function getClubMember(clubId, wasAccept?): Promise<ClubUser[]> {
  let baseUrl = environment.api.club.getUsers

  if (wasAccept === void 0) baseUrl = baseUrl.replace('wasAccepted={wasAccepted}', '')

  const url = baseUrl
    .replace('{clubId}', String(clubId))
    .replace('{wasAccepted}', String(wasAccept || ''))

  const data = await api.get(url)
    .then(resp => resp?.data.success)
    .catch(error => 0);

  return data;
}

export async function joinTheClub(userId: number, clubId: number): Promise<AsyncResult<ClubUser>> {
  const baseUrl = environment.api.club.addUserInClub

  const url = baseUrl
    .replace('{userId}', String(userId))
    .replace('{clubId}', String(clubId))

  const response = await api.post(url)
    .then(resp => { return { success: resp?.data.success, error: void 0 } })
    .catch((error) => { return { success: void 0, error: error.response.data.error } });

  if (response.error) return { error: response.error }

  return { success: response.success };
}

export async function editUserInClub(userId: number, clubId: number, action: userClubActions): Promise<AsyncResult<number>> {
  const baseUrl = environment.api.club.editUserInClub

  const url = baseUrl
    .replace('{userId}', String(userId))
    .replace('{action}', String(action))
    .replace('{clubId}', String(clubId))

  const response = await api.put(url)
    .then(resp => { return { success: resp?.data.success, error: void 0 } })
    .catch((error) => { return { success: void 0, error: error.response.data.error } });

  if (response.error) return { error: response.error }

  return { success: response.success };
}